import {
  Box,
  Button,
  CircularProgress,
  FormControl,
  MenuItem,
  Select,
  Stack,
  TextField,
  Typography,
} from "@mui/material";
import React from "react";
import {
  SupervisorAccount as SupervisorAccountIcon,
  PersonOutlineOutlined as PersonOutlineOutlinedIcon,
} from "@mui/icons-material";
import AddButton from "../../../containers/super-admin/add-button";
import { inputCommonStyle } from "../../../util/admin/cssCommonStyle";
import { useAtom } from "jotai";
import { SAdminBaseAtom } from "../../../stores/jotai/super-admin/superAdminBase";
import { useKeycloak } from "@react-keycloak/web";
import { useQueryClient } from "@tanstack/react-query";
import { useUpdateGroup } from "../../../tanstackQuery/queries/superAdmin/group";
import { toast } from "sonner";
import { useFormik } from "formik";
import { useGetCanvasLayout } from "../../../tanstackQuery/queries/canvas";
import { AiSettingsModal } from "./teamConfig/aiSettingsModal";

const TeamInfoCard = ({ teamDetails, teamApiDataParams }) => {
  const { keycloak } = useKeycloak();
  const client = useQueryClient();
  const {
    mutateAsync: updateTeam,
    isPending,
    isSuccess,
  } = useUpdateGroup(
    { accessToken: keycloak?.token },
    {
      onSuccess: () => {
        client.invalidateQueries({ queryKey: ["orgtree"] });
        client.invalidateQueries({ queryKey: ["orgCohortDetails"] });
        toast.success("Team updated successfully!");
      },
    }
  );

  const { data: canvasLayoutData, isLoading: isLayoutLoading } = useGetCanvasLayout({ accessToken: keycloak.token });
  const canvasType = canvasLayoutData?.filter(type => type.name !== null)?.map((type) => type.name);
  const formik = useFormik({
      enableReinitialize: true,
      initialValues: {
        name: teamDetails?.name || "",
        canvasType:teamDetails?.canvasType || "BusinessModelCanvas"
      },
      onSubmit: (values) => {
        handleSubmitTeamInfo(values);
      },
    });

    const handleSubmitTeamInfo = async (values) => {
      const updatedTeamData = {
         ...values,
         groupID:teamApiDataParams?.teamID,
         orgID:teamApiDataParams?.orgID,
         //parentGroupID: sAdminBase?.selectedGroup?.parentID
      };
      try {
        await updateTeam(updatedTeamData);
        if (isSuccess) {
          formik.resetForm();
        }
      } catch (error) {
        toast.error(error?.response?.data?.message || "Failed to update Team.");
      }
   }

  return (
    <form onSubmit={formik.handleSubmit}>
      <Stack
        direction="row"
        justifyContent="space-around"
        sx={{
          backgroundColor: "white",
          display: "flex",
          borderRadius: "4px",
          p: "24px 12px",
          my: 2,
        }}
      >
        <Stack direction="column" justifyContent="center">
          <Stack direction="row" alignItems="center">
            <Box sx={{ flexBasis: "40%" }}>
              <Typography sx={{ fontWeight: "bold" }}> Team Name</Typography>
            </Box>
            <Box sx={{ flexBasis: "60%" }}>
              <TextField
                id="outlined-basic"
                variant="outlined"
                size="small"
                name="name"
                value={formik.values.name}
                onChange={formik.handleChange}
                fullWidth
                sx={inputCommonStyle}
              />
            </Box>
          </Stack>
        </Stack>

        <Stack direction="column" justifyContent="center">
          <Stack direction="row" gap={5} alignItems="center">
            <Box sx={{ flexBasis: "40%" }}>
              <Typography sx={{ fontWeight: "bold" }}> Canvas</Typography>
            </Box>
            <Box sx={{ flexBasis: "60%" }}>
              <FormControl sx={{ minWidth: 270, ...inputCommonStyle }}>
                  <Select
                    name="canvasType"
                    size="small"
                    value={formik.values.canvasType}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                  >
                    {canvasType?.map((name,index) => (
                      <MenuItem key={index+name} value={name}>{name}</MenuItem>
                    ))}
                  </Select>
              </FormControl>
            </Box>
          </Stack>
        </Stack>
        <Stack direction="column" justifyContent="center">
          <Stack direction="row" alignItems="center">
             <AiSettingsModal teamApiDataParams={teamApiDataParams}/>
          </Stack>
        </Stack>

        <Stack direction="column" justifyContent="space-between">
          <Stack direction="row" gap={1}>
            <Button 
               type="submit" 
               fullWidth 
               variant="contained"
               disabled={!formik.dirty || isPending}
               endIcon={isPending ? <CircularProgress size={16} /> : null}
            >
              Update
            </Button>
            <Button fullWidth variant="contained">
              Delete
            </Button>
          </Stack>
        </Stack>
      </Stack>
    </form>
  );
};

export default TeamInfoCard;
